import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';

export const TNCStyle = styled.div`
  color: ${colors.LightGrayColor};
  position: relative;
  ${ZeeFontRegular(11, 18)};
  width: 100%;
  ${MediaBP.MediaLg} {
    ${ZeeFontRegular(14, 20)};
  }
`;

export const TNCLink = styled.a`
  color: ${colors.Lavender};
`;
